import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=3fa2834e&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=ts"
export * from "./Feedback.vue?vue&type=script&lang=ts"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=3fa2834e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2834e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa2834e')) {
      api.createRecord('3fa2834e', component.options)
    } else {
      api.reload('3fa2834e', component.options)
    }
    module.hot.accept("./Feedback.vue?vue&type=template&id=3fa2834e&scoped=true", function () {
      api.rerender('3fa2834e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/Feedback.vue"
export default component.exports